/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CompanyWebhookDeliveryTrigger {
  System = "system",
  Customer = "customer",
  Ops = "ops",
}

export function instanceOfCompanyWebhookDeliveryTrigger(value: any): boolean {
  for (const key in CompanyWebhookDeliveryTrigger) {
    if (
      Object.prototype.hasOwnProperty.call(CompanyWebhookDeliveryTrigger, key)
    ) {
      if (
        CompanyWebhookDeliveryTrigger[
          key as keyof typeof CompanyWebhookDeliveryTrigger
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CompanyWebhookDeliveryTriggerFromJSON(
  json: any,
): CompanyWebhookDeliveryTrigger {
  return CompanyWebhookDeliveryTriggerFromJSONTyped(json, false);
}

export function CompanyWebhookDeliveryTriggerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyWebhookDeliveryTrigger {
  return json as CompanyWebhookDeliveryTrigger;
}

export function CompanyWebhookDeliveryTriggerToJSON(
  value?: CompanyWebhookDeliveryTrigger | null,
): any {
  return value as any;
}

export function CompanyWebhookDeliveryTriggerToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CompanyWebhookDeliveryTrigger {
  return value as CompanyWebhookDeliveryTrigger;
}
